export class ValidarContasPagarImportacaoRequest {
    arquivoBase64!: string;
}
